function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.333 9.167a2.49 2.49 0 002.492-2.5c0-1.384-1.108-2.5-2.492-2.5a2.496 2.496 0 00-2.5 2.5c0 1.383 1.117 2.5 2.5 2.5zm-6.666 0a2.49 2.49 0 002.491-2.5c0-1.384-1.108-2.5-2.491-2.5a2.496 2.496 0 00-2.5 2.5c0 1.383 1.116 2.5 2.5 2.5zm0 1.666c-1.942 0-5.834.975-5.834 2.917v2.083H12.5V13.75c0-1.942-3.892-2.917-5.833-2.917zm6.666 0c-.241 0-.516.017-.808.042.967.7 1.642 1.642 1.642 2.875v2.083h5V13.75c0-1.942-3.892-2.917-5.834-2.917z"
});

function SvgGroupIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20
  }, props), _ref);
}

export default SvgGroupIcon;